/* ─── Weekindeling ───────────────────────────────────────────────────────────
   De bakkerij houdt zondag als eerste dag van de week aan: in de footer, op
   de openingstijden-pagina, in de bestelkalender en in Beheer. Overal waar een
   week wordt getoond gaat de volgorde via dit bestand, zodat het niet per
   scherm uit elkaar loopt.

   `dayIndex` volgt de JS-conventie van `Date#getDay()`: 0 = zondag … 6 = zaterdag.
   Dat is óók wat er in de database staat (DaySchedule.dayIndex), dus de index
   hoeft nergens omgerekend te worden — alleen de vólgorde van weergave. */

/** Eerste kolom van de week. 0 = zondag. */
export const WEEK_START_DAY = 0

/** dayIndexen in weergavevolgorde: zondag → zaterdag. */
export const WEEK_DAY_ORDER: readonly number[] = [0, 1, 2, 3, 4, 5, 6].map(
  (i) => (i + WEEK_START_DAY) % 7,
)

/** Labels op positie `getDay()` — dus NIET in weergavevolgorde. */
export const DAY_LABELS_SHORT = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'] as const
export const DAY_NAMES_FULL   = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'] as const

/** Kolomkoppen van een maandkalender, in weergavevolgorde. */
export const WEEK_HEADER_LABELS: readonly string[] = WEEK_DAY_ORDER.map((d) => DAY_LABELS_SHORT[d])

/** Hoeveel lege cellen vóór de 1e van de maand staan. */
export function firstDayOffset(year: number, month: number): number {
  return (new Date(year, month, 1).getDay() - WEEK_START_DAY + 7) % 7
}

/** Sorteert rijen met een `dayIndex` naar de weergavevolgorde van de week. */
export function sortByWeekOrder<T extends { dayIndex: number }>(rows: readonly T[]): T[] {
  return [...rows].sort(
    (a, b) => WEEK_DAY_ORDER.indexOf(a.dayIndex) - WEEK_DAY_ORDER.indexOf(b.dayIndex),
  )
}
